import React from 'react';

const facts = [
    { label: 'ISSN (in review)', value: 'XXXX-XXXX' },
    { label: 'Frequency', value: 'Biannual — July & December' },
    { label: 'Language', value: 'English' },
    { label: 'Access', value: 'Open Access — No APC' },
    { label: 'Review Type', value: 'Double-blind peer review' },
    { label: 'Published by', value: 'K.R. Mangalam University, Gurugram' },
];

const JournalDetailsCard = () => (
    <div className="sidebar-card">
        <h3 className="sidebar-card__title">Journal Details</h3>
        <dl className="sidebar-facts">
            {facts.map(({ label, value }) => (
                <div className="sidebar-facts__row" key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                </div>
            ))}
        </dl>
    </div>
);

export default JournalDetailsCard;
